/*
 *  main lesson-editor container - sets up context for all lesson types
 */

import React, { useContext, useEffect } from 'react';
import { Container, createTheme, ThemeProvider } from '@material-ui/core';
import { StylesProvider } from '@material-ui/core/styles';
import styled from 'styled-components/macro';
import EditorHeader from '../components/EditorHeader';
import LessonEditor from '../pages/LessonEditor';
import GlobalContext from '../../modules/contexts/global';
import EditorContext from '../modules/contexts/editor';

const theme = createTheme({
    typography: {
        fontSize: 12,
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    },
    spacing: 4,
});

const PageContainer = styled(Container)`
    font-family: Roboto, Helvetica, Arial, sans-serif;
    position: relative;
    // height: 100%;
`;

const LessonContainer = () => {
    const global = useContext(GlobalContext);
    const editor = useContext(EditorContext);

    useEffect(() => {
        return async () => {
            // unmounting, release edit lock
            if (global.currentLessonObject)
                await editor.endEditLesson(global.currentLessonObject._id);
        }
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <StylesProvider injectFirst>
                <EditorHeader />
                <PageContainer maxWidth={false}>
                    <LessonEditor />
                </PageContainer>
            </StylesProvider>
        </ThemeProvider>
    );
};

export default LessonContainer;


